import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-16 pb-8 relative overflow-hidden">
            <div className="absolute inset-0 bg-black opacity-20" />
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-indigo-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center gap-2 mb-4">
                            <Sparkles className="w-8 h-8 text-indigo-400" />
                            <h3 className="text-2xl font-bold bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                                Studytino
                            </h3>
                        </div>
                        <p className="text-gray-300 text-sm leading-relaxed max-w-md">
                            Lerne effizient mit KI-generierten Karteikarten oder erstelle deine eigenen.
                            Perfekt für Schüler, Studenten und alle, die ihr Wissen spielerisch erweitern möchten.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4 text-indigo-300">Navigation</h4>
                        <ul className="space-y-2">
                            {[
                                { to: '/', label: 'Home' },
                                { to: '/erstellen', label: 'Skript hochladen' },
                                { to: '/lernsets', label: 'Meine Lernsets' },
                                { to: '/login', label: 'Login' },
                            ].map((item) => (
                                <motion.li
                                    key={item.to}
                                    whileHover={{ x: 6 }}
                                    transition={{ type: 'spring', stiffness: 300 }}
                                >
                                    <Link
                                        to={item.to}
                                        className="text-gray-300 hover:text-white transition-colors flex items-center gap-1 group"
                                    >
                                        {item.label}
                                        <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                                    </Link>
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4 text-indigo-300">Rechtliches</h4>
                        <ul className="space-y-2">
                            {[
                                { to: '/impressum', label: 'Impressum' },
                                { to: '/datenschutz', label: 'Datenschutz' },
                                { to: '/agb', label: 'AGB' },
                                { to: '/widerruf', label: 'Widerruf' },
                            ].map((item) => (
                                <motion.li
                                    key={item.to}
                                    whileHover={{ x: 6 }}
                                    transition={{ type: 'spring', stiffness: 300 }}
                                >
                                    <Link
                                        to={item.to}
                                        className="text-gray-300 hover:text-white transition-colors flex items-center gap-1 group"
                                    >
                                        {item.label}
                                        <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                                    </Link>
                                </motion.li>
                            ))}
                        </ul>
                    </div>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400 text-sm"
                >
                    © {currentYear} Studytino – Alle Rechte vorbehalten.
                </motion.div>
            </div>
        </footer>
    );
};

export default Footer;